module.exports = __webpack_public_path__ + "img/Spot Lights.a1b9faf0.jpeg";